import { Button } from "src/components";
import downArrow from "src/assets/down-arrow.svg";
import { useState } from "react";
import moment from "moment";
import { AlertTriangle } from "lucide-react"; //M10-14958
import { downloadInvoice } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";

// M10-14958
const formatRejectionCode = (code?: string) =>
  code ? code.replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";
// M10-14958
interface OrderInfoFuidCardProps {
  fuid: any;
  index: number;
  company_code: string;
}

const OrderInfoFuidCard = ({ fuid, index, company_code }: OrderInfoFuidCardProps) => {
  const [isExpanded, setIsExpanded] = useState(index === 0);
  const { toast } = useToast();
  const hasRejectionDetails = fuid?.is_rejection_pending == true; //M10-15087

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleFuidClick = () => {
    if (hasRejectionDetails) return; //M10-15087         
    const statusId = fuid?.fileStatusHdr?.fuid_status_id;
    const attachmentId = fuid?.stockist_invoice_attachment_id;
    // The target screen opens in a new tab and cannot read react-router
    // location.state, so company_code is handed over via localStorage instead
    // of the URL (avoids exposing it in query params / browser history).
    window.localStorage.setItem("company_code", company_code);

    if (statusId === 1 || statusId === 22) {
      window.open(`/transactions/invoice/${attachmentId}/0`, "_blank");
    } else if (statusId === 6 || statusId === 8) {
      window.open(`/transactions/invoice/${attachmentId}/1`, "_blank");
    } else {
      // Generic user-friendly message
      toast({
        title: "Redirect Failed",
        description: "We couldn't open the requested page. Please try again later.",
        variant: "destructive",
      });
    }
  };

  return (
    <div>
      <div className="mt-6 w-full mx-auto shadow-sm border border-[#D0D0D0] rounded-xl p-6 bg-white">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            {/* M10-10765 */}
            <div className="flex items-center gap-4">
              {/* FUID Number */}
              <p
                className={`group font-semibold text-xl ${hasRejectionDetails ? "" : "cursor-pointer"}`}  //M10-15087
                onClick={handleFuidClick}
              >
                FUID{" "}
                <span className={hasRejectionDetails ? "text-gray-500" : "text-gray-500 group-hover:text-[#6b40d6]"}>
                  #{fuid?.fuid_no}
                </span>
              </p>

              {/* Status Badge */}
              <span
                className="font-medium flex items-center justify-center text-sm h-6 px-3 rounded-full shadow-sm"
                style={{
                  backgroundColor: fuid?.fileStatusHdr?.color_code?.trim(),
                  color: fuid?.fileStatusHdr?.text_color_code?.trim(),
                }}
              >
                {fuid?.fileStatusHdr?.fuid_status_desc}
              </span>
            </div>
            {/* <div className="flex gap-2">
              <p
                className="font-semibold flex items-center w-fit mt-2 text-[.8rem] h-6 px-2 rounded-full"
                style={{
                  backgroundColor: fuid?.fileStatusHdr?.color_code?.trim(),
                  color: fuid?.fileStatusHdr?.text_color_code?.trim(),
                }}
              >
                {fuid?.fileStatusHdr?.fuid_status_desc}
              </p>
              <p className="font-semibold flex items-center w-fit mt-2 text-[.8rem] h-6 px-2 rounded-full bg-[#EAF4FF] text-[#002E6A]">
                {fuid?.orderCodes?.map((orderCode: any) => orderCode?.order_code).join(", ")}
              </p>
            </div>  */}
            <div className="mt-2 space-y-1">
              {/* Stockist Selected */}
              <div className="flex items-start gap-2">
                <p className="font-semibold min-w-[250px]">
                  Stockist Selected Order Number:
                </p>
                <span className="text-gray-700">
                  {fuid?.orderCodes
                    ?.map((orderCode: any) => orderCode?.order_code)
                    .join(", ") || "—"}
                </span>
              </div>

              {/* Invoice Considered */}
              <div className="flex items-start gap-2">
                <p className="font-semibold min-w-[250px]">
                  Invoice Considered Order Number:
                </p>
                <span className="text-gray-700">
                  {
                    Array.from(
                      new Set(
                        fuid?.invoice?.invoiceProducts?.flatMap((orderCode: any) =>
                          orderCode?.orderProductMappings?.map(
                            (invoiceOrder: any) => invoiceOrder?.orderProduct?.order?.order_code
                          )
                        ) || []
                      )
                    ).join(", ") || "—"
                  }
                </span>
              </div>
              {/* M10-10765 */}
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              className="font-normal text-white bg-[#8051FF]"
              onClick={() => {
                if (!fuid?.file_path) {
                  toast({ description: "Invoice not found", variant: "destructive" });
                  return;
                }

                toast({ title: "Downloading...", description: "Downloading invoice", variant: "default" });

                downloadInvoice(fuid?.file_path, company_code as string).then((res: any) => {
                  if (res?.data?.success && res?.data?.data) {
                    window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                  } else {
                    console.error("Failed to download the invoice.");
                  }
                });
              }}
            >
              {/* M10-12866 */}
              Invoice Download
            </Button>
            {/* M10-13684 */}
            {fuid?.stockist_po_file_path &&
              <Button
                className="font-normal text-white bg-[#8051FF]"
                onClick={() => {
                  if (!fuid?.stockist_po_file_path) {
                    toast({ description: "PO not found", variant: "destructive" });
                    return;
                  }

                  toast({ title: "Downloading...", description: "Downloading invoice", variant: "default" });

                  downloadInvoice(fuid?.stockist_po_file_path, company_code as string).then((res: any) => {
                    if (res?.data?.success && res?.data?.data) {
                      window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                    } else {
                      console.error("Failed to download the invoice.");
                    }
                  });
                }}
              >
                PO Download
                {/* M10-12866 */}
              </Button>
            }
            {/* M10-13684 */}
            <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
              <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
            </Button>
          </div>
        </div>{" "}
        <div
          className={`transition-all items-center duration-500 ease-in-out overflow-hidden ${isExpanded ? "opacity-100 max-h-[1000px]" : "max-h-0 opacity-0"}`}
          style={{ transitionProperty: "max-height, opacity" }}
        >
          <div className="border-t mt-6 border-[#d0d0d0]"></div>
          <div className="flex gap-10">
            <div className="mt-4 space-y-4 w-1/2">
              <div className="text-[1rem] flex gap-20">
                <p className="text-[#616161]">Uploaded on</p>
                <p className="text-[#303030]">  {moment(fuid?.created_date).format("MMMM Do YYYY, hh:mm A")}</p> 
              </div>
              <div className="text-[1rem] flex gap-20">
                <p className="text-[#616161]">Uploaded by</p>
                <p className="text-[#303030]">{fuid?.uploader_name}</p>
              </div>
            </div>
            {fuid?.invoiceRemarks?.length > 0 && (
              <div className="mt-4 space-y-4 w-1/2">
                <p className="font-semibold text-[1.2rem]">Remarks</p>
                <p className="text-[#616161] inline-block mr-20">Category</p>
                <p className="text-[#303030] inline-block">
                  {fuid?.invoiceRemarks[0]?.RejectionInvoiceCategoryHdr?.rejection_inv_category_desc}
                </p>
                <div className="border space-y-1 mt-6 border-[#d0d0d0] min-h-[6rem] min-w-[20rem] w-fit rounded-lg bg-[#F1F1F1] p-4">
                  <p className="text-[#7F56D9] font-normal text-[1rem]">
                    {fuid?.invoiceRemarks[0]?.remarkby_type}
                  </p>
                  <p className="text-[#303030] font-normal text-[1rem]">
                    <span className="font-semibold">
                      {" "}
                      {fuid?.invoiceRemarks[0]?.invoiceRemarksHdr?.invoice_remarks_desc}
                    </span>{" "}
                    : ({fuid?.invoiceRemarks[0]?.freetxt_remarks})
                  </p>
                  <p className="text-[#616161] font-normal text-[.8rem]">
                    {moment(fuid?.invoiceRemarks[0]?.created_date).format("MMMM Do YYYY")}
                  </p>
                </div>
              </div>
            )}
          </div>
          {/* M10-14958 */}
          {fuid?.rejection_code && (fuid?.is_rejection_pending == true || [2,4].includes(fuid?.fileStatusHdr?.fuid_status_id)) && (() => {
            // Generic key/value rendering for rejection_data_email_desc — mirrors
            // InvoiceEntryScreen.tsx's FUID rejection-review formatting so any new
            // field (e.g. product_code, product_name, mrp) shows up without a code change.
            const formatKey = (key: string) =>
              key
                .replace(/[_-]+/g, " ")
                .replace(/([a-z])([A-Z])/g, "$1 $2")
                .replace(/\b\w/g, (c) => c.toUpperCase());

            const isIsoDateString = (value: any) =>
              typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value) && !isNaN(new Date(value).getTime());

            const formatValue = (value: any): string => {
              if (value === null || value === undefined || value === "") return "";
              if (isIsoDateString(value)) {
                const d = new Date(value);
                return `${d.toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}, ${d.toLocaleTimeString("en-GB", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}`;
              }
              if (typeof value === "object") return JSON.stringify(value, null, 2);
              return String(value);
            };

            const labelOverrides: Record<string, string> = {
              rejection_remark: "Rejection Remarks",
              sub_remarks: "Rejection Sub Remarks",
              rejected_at: "Rejected Date",
            };
            const orderedKeys = [
              "rejection_header",
              "rejection_remark",
              "sub_remarks",
              "invoice_number",
              "invoice_date",
              "rejected_by_name",
              "rejected_at",
              "corrective_hint",
            ];
            const combinedData: Record<string, any> = { ...(fuid?.rejection_data_email_desc || {}) };
            const excludedKeys = new Set(["rejected_by", "rejected_by_role"]);
            // Any keys beyond the fixed sequence (e.g. product_code, product_name, mrp)
            // still show up, appended after Corrective Hint in whatever order the data provides.
            const extraKeys = Object.keys(combinedData).filter(
              (key) => !orderedKeys.includes(key) && !excludedKeys.has(key)
            );

            const entries = [...orderedKeys, ...extraKeys]
              .map((key): [string, any] => [key, combinedData[key]])
              .filter(([, v]) => v !== null && v !== undefined && v !== "");

            return (
              <div className="mt-6 rounded-lg border border-[#FCA5A5] bg-[#FEF2F2] overflow-hidden">
                <div className="px-5 py-3 bg-[#FEE2E2] border-b border-[#FCA5A5] flex items-center gap-2">
                  <AlertTriangle className="w-4 h-4 text-[#7F1D1D]" aria-hidden="true" />
                  <h3 className="text-[#7F1D1D] font-semibold text-base">Rejection Details</h3>
                </div>

                <div className="px-5 py-4 space-y-4">
                  <span className="inline-block text-xs font-semibold uppercase tracking-wide px-3 py-1 rounded-full bg-[#FEE2E2] text-[#9B2C2C] border border-[#FCA5A5]">
                    {formatRejectionCode(fuid?.rejection_code)}
                  </span>

                  {entries.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-sm pt-2 border-t border-[#FCA5A5]/40">
                      {entries.map(([key, value]) => {
                        const formatted = formatValue(value);
                        const isLong = formatted.length > 60 || /\n/.test(formatted);
                        return (
                          <div
                            key={key}
                            className={`flex items-start gap-2 ${isLong ? "sm:col-span-2 flex-col" : ""}`}
                          >
                            <p className="text-[#616161] min-w-[110px]">{labelOverrides[key] || formatKey(key)}</p>
                            <span className="text-[#303030] font-medium whitespace-pre-wrap break-words">
                              {formatted}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {(fuid?.rejection_review_action_by || fuid?.rejection_review_action_date) && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-xs pt-3 border-t border-dashed border-[#FCA5A5]/40 text-[#8A8A8A]">
                      <div className="flex items-start gap-2">
                        <p className="min-w-[110px]">Reviewed By</p>
                        <span>{fuid?.rejection_review_action_by || "—"}</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <p className="min-w-[110px]">Reviewed On</p>
                        <span>
                          {fuid?.rejection_review_action_date
                            ? moment(fuid.rejection_review_action_date).format("MMMM Do YYYY, hh:mm A")
                            : "—"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
          {/* M10-14958 */}
        </div>
      </div>
    </div>
  );
};

export default OrderInfoFuidCard;
